let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jCvJI")).then(() => parcelRequire('im5Hg'));